// UserProgressSection.jsx
import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import "./UserProgressSection.css";
import analyticsService from "../../../services/analyticsService";

function UserProgressSection() {
  const [totalUsers, setTotalUsers] = useState(0);
  const [criteriaData, setCriteriaData] = useState({
    "25%": 0,
    "50%": 0,
    "75%": 0,
    "100%": 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUserProgress = async () => {
      try {
        setLoading(true);
        const response = await analyticsService.getDashboardAnalytics();

        if (response.success && response.data) {
          const { totalUsers: total, profileCompletion } = response.data;

          setTotalUsers(total || 0);

          if (profileCompletion) {
            setCriteriaData({
              "25%": profileCompletion.complete25 || 0,
              "50%": profileCompletion.complete50 || 0,
              "75%": profileCompletion.complete75 || 0,
              "100%": profileCompletion.complete100 || 0,
            });
          }
        }
      } catch (error) {
        console.error("Error fetching user progress analytics:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUserProgress();
  }, []);

  return (
    <motion.div
      className="user-progress-section"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      viewport={{ once: true }}
    >
      <div className="section-title">
        <h2>Total Users: {totalUsers}</h2>
        <span className="material-symbols-outlined">group</span>
      </div>

      <div className="progress-grid">
        {Object.entries(criteriaData).map(([criteria, count]) => (
          <div key={criteria} className="progress-card">
            <p className="criteria">{criteria} Complete</p>
            <p className="count">{count} Users</p>
            {/* Example of a basic progress bar */}
            <div className="progress-bar">
              <div className="progress-fill" style={{ width: criteria }} />
            </div>
          </div>
        ))}
      </div>
    </motion.div>
  );
}

export default UserProgressSection;
